<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <a-form-model
        layout=""
        :model="formInline"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="门店名称">
              <a-input v-model="formInline.user" placeholder="请输入门店名称">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="联系电话">
              <a-input v-model="formInline.user" placeholder="请输入联系电话">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="负责人姓名">
              <a-input v-model="formInline.user" placeholder="请输入负责人姓名">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="负责人电话">
              <a-input v-model="formInline.user" placeholder="请输入负责人电话">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="门店分类">
              <a-select
                default-value="lucy"
                style="width: 100%"
                @change="handleChange"
              >
                <a-select-option value="jack"> 请选择 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="营业时间">
              <a-range-picker @change="onChange" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="24">
            <a-form-model-item label="门店简介" :labelCol="textarealabelCol" :wrapperCol="textareaWrapperCol">
              <a-textarea
                v-model="value"
                placeholder="Controlled autosize"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="上传负责人证件">
              <a-row>
                <a-col :span="12">

                </a-col>
                <a-col :span="12">

                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
      </a-form-model>
    </div>

    <!-- 营业执照信息 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 营业执照信息 </a-col>
      </a-row>
      <a-form-model
        layout=""
        :model="formInline"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="执照名称">
              <a-input v-model="formInline.user" placeholder="请输入执照名称">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="执照注册号">
              <a-input
                v-model="formInline.user"
                placeholder="请输入社会统一代码"
              >
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="上传营业执照">
              <a-row>
                <a-col :span="12">

                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 地址信息 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 地址信息 </a-col>
      </a-row>
      <a-form-model
        layout=""
        :model="formInline"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="归属地">
              <a-input v-model="formInline.user" placeholder="请输入门店名称">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="详细地址">
              <a-input v-model="formInline.user" placeholder="请输入联系电话">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="地址搜索">
              <a-input
                v-model="formInline.user"
                placeholder="请输入商户地址，或附近地标"
              >
              </a-input>
              <!-- <span class="illustrate">1.参考地图定位，如果商家坐标不符，请纠正定位信息</span>
              <span class="illustrate">2.使用地址辅助搜索可快速定位商户所属地，点击地图获取商户精确坐标</span> -->
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label=" ">
              <span class="illustrate"
                >1.参考地图定位，如果商家坐标不符，请纠正定位信息</span
              >
              <span class="illustrate"
                >2.使用地址辅助搜索可快速定位商户所属地，点击地图获取商户精确坐标</span
              >
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
      </a-form-model>
    </div>
  </div>
</template>

<script>


export default {
  components: {  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      textarealabelCol: { span: 2 },
      textareaWrapperCol:{span: 21, offset: 1},
      formInline: {
        user: "",
        password: "",
      },
    };
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
    },
    onChange(date, dateString) {
      console.log(date, dateString);
    },
  },
};
</script>

<style lang="scss" scoped="" type="text/css">
.illustrate {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/bargainingOrder/bargainingOrderDetails.vue